"use client"

import { useEffect, useState } from "react"

export default function ScrollProgress() {
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        let ticking = false

        const updateProgress = () => {
            const scrollTop = window.scrollY
            const docHeight = document.documentElement.scrollHeight - window.innerHeight
            const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0
            setProgress(scrollPercent)
            ticking = false
        }

        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(updateProgress)
                ticking = true
            }
        }

        window.addEventListener("scroll", onScroll, { passive: true })
        return () => window.removeEventListener("scroll", onScroll)
    }, [])

    return (
        <div className="fixed top-0 left-0 right-0 z-[60] h-[3px]">
            <div
                className="h-full bg-blue-600"
                style={{
                    width: `${progress}%`,
                    transition: "none",
                    willChange: "width",
                }}
            />
        </div>
    )
}
